<ng-container [formGroup]="form">
  <ix-fieldset [title]="'Authentication' | translate">
    <ix-input
      formControlName="user"
      [label]="'User Name' | translate"
      [required]="true"
      [tooltip]="helptext.user_openstack_swift.tooltip | translate"
    ></ix-input>

    <ix-input
      formControlName="key"
      type="password"
      [label]="'API Key or Password' | translate"
      [required]="true"
      [tooltip]="helptext.key_openstack_swift.tooltip | translate"
    ></ix-input>

    <ix-input
      formControlName="auth"
      [label]="'Authentication URL' | translate"
      [required]="true"
      [tooltip]="helptext.auth_openstack_swift.tooltip | translate"
    ></ix-input>

    <ix-select
      formControlName="auth_version"
      [label]="'AuthVersion' | translate"
      [required]="true"
      [options]="authVersions$"
      [tooltip]="helptext.auth_version_openstack_swift.tooltip | translate"
    ></ix-select>
  </ix-fieldset>

  <ix-fieldset [title]="'Advanced Options' | translate">
    @if (isVersion3) {
      <ix-input
        formControlName="user_id"
        [label]="'User ID' | translate"
        [tooltip]="helptext.user_id_openstack_swift.tooltip | translate"
      ></ix-input>
      <ix-input
        formControlName="domain"
        [label]="'User Domain' | translate"
        [tooltip]="helptext.domain_openstack_swift.tooltip | translate"
      ></ix-input>
    }
    <ix-input
      formControlName="tenant"
      [label]="'Tenant Name' | translate"
      [tooltip]="helptext.tenant_openstack_swift.tooltip | translate"
    ></ix-input>

    <ix-input
      formControlName="tenant_id"
      [label]="'Tenant ID' | translate"
      [tooltip]="helptext.tenant_id_openstack_swift.tooltip | translate"
    ></ix-input>

    @if (isVersion3) {
      <ix-input
        formControlName="tenant_domain"
        [label]="'Tenant Domain' | translate"
        [tooltip]="helptext.tenant_domain_openstack_swift.tooltip | translate"
      ></ix-input>
    }

    <ix-input
      formControlName="auth_token"
      type="password"
      [label]="'Auth Token' | translate"
      [tooltip]="helptext.auth_token_openstack_swift.tooltip | translate"
    ></ix-input>

    <ix-input
      formControlName="region"
      [label]="'Region Name' | translate"
      [tooltip]="helptext.region_openstack_swift.tooltip | translate"
    ></ix-input>

    <ix-input
      formControlName="storage_url"
      [label]="'Storage URL' | translate"
      [tooltip]="helptext.storage_url_openstack_swift.tooltip | translate"
    ></ix-input>

    <ix-select
      formControlName="endpoint_type"
      [label]="'Endpoint Type' | translate"
      [options]="endpointTypes$"
      [required]="true"
      [tooltip]="helptext.endpoint_type_openstack_swift.tooltip | translate"
    ></ix-select>
  </ix-fieldset>
</ng-container>
